var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8489 2.15113C15.8572 0.159461 12.6281 0.159461 10.6364 2.15113L9.22217 3.56535C8.98786 3.79966 8.98786 4.17956 9.22217 4.41388C9.45649 4.64819 9.83638 4.64819 10.0707 4.41388L11.4849 2.99966C13.008 1.47662 15.4773 1.47662 17.0003 2.99966C18.5234 4.52271 18.5234 6.99205 17.0003 8.5151L14.5255 10.99C13.0024 12.513 10.5331 12.513 9.01004 10.99L8.65649 10.6364C8.42217 10.4021 8.04227 10.4021 7.80796 10.6364C7.57364 10.8707 7.57364 11.2506 7.80796 11.4849L8.16151 11.8385C10.1532 13.8302 13.3823 13.8302 15.374 11.8385L17.8489 9.36362C19.8405 7.37195 19.8405 4.14281 17.8489 2.15113ZM5.47451 9.01007C6.99755 7.48703 9.46689 7.48703 10.9899 9.01007L11.3435 9.36362C11.5778 9.59794 11.9577 9.59794 12.192 9.36362C12.4263 9.12931 12.4263 8.74941 12.192 8.5151L11.8385 8.16154C9.84679 6.16987 6.61765 6.16987 4.62598 8.16154L2.1511 10.6364C0.15943 12.6281 0.15943 15.8572 2.1511 17.8489C4.14278 19.8406 7.37192 19.8406 9.36359 17.8489L10.7778 16.4347C11.0121 16.2004 11.0121 15.8205 10.7778 15.5862C10.5435 15.3518 10.1636 15.3518 9.92928 15.5862L8.51506 17.0004C6.99202 18.5234 4.52268 18.5234 2.99963 17.0004C1.47659 15.4773 1.47659 13.008 2.99963 11.4849L5.47451 9.01007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.12ebff5bee86c84140f9372a3eb23d29.svg";
export { ForwardRef as ReactComponent };